var $46252cd87269b10b$exports = {};
$46252cd87269b10b$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " nije izabrano.");
  },
  "longPressToSelect": "Dugo pritisnite za ulazak u re\u017Eim biranja.",
  "select": "Izaberite",
  "selectedAll": "Izabrane su sve stavke.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nije izabrana nijedna stavka",
      one: function one() {
        return "Izabrana je ".concat(formatter.number(args.count), " stavka");
      },
      other: function other() {
        return "Izabrano je ".concat(formatter.number(args.count), " stavki");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " je izabrano.");
  }
};
export { $46252cd87269b10b$exports as default };